const my_profile = {
  viewMyClubSeacretProfile: "Lihat Profil ClubSecret Saya", // translated 
  viewMoreDetails: "Lihat Lebih Detail", // translated 
  verifiedEmail: "Email Terverifikasi", // translated 
  unverifiedEmail: "Email Belum Diverifikasi", // translated 
  balance: "Keseimbangan", // translated 
  pointsIn: "Poin Masuk", // translated 
  pointsOut: "Menunjukkan", // translated 
  topUp: "Isi Ulang", // translated 
  pointsHistoryTable: "Tabel Riwayat Poin", // translated 
};


export default my_profile;
